import React from 'react';

import { describeArc } from './lib/describe-arc';

export type SegmentData = {
  value: number;
  color: string;
};

export type DoughnutSegmentProps = {
  cx: number;
  cy: number;
  radius: number;
  strokeWidth: number;
  startAngle: number;
  endAngle: number;
  gapAngle: number;
  segment: SegmentData;
  isActive: boolean;
  animateFill: boolean;

  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick?: (event: React.MouseEvent<SVGElement>, segment: SegmentData) => void;
};

const DoughnutSegment = (props: DoughnutSegmentProps) => {
  const {
    cx,
    cy,
    radius,
    strokeWidth,
    startAngle,
    endAngle,
    gapAngle,
    segment,
    isActive,
    animateFill,
    onMouseEnter,
    onMouseLeave,
    onClick
  } = props;

  const circumference = 2 * Math.PI * radius;
  // Total angle for this segment including the gap.
  const fullAngle = endAngle - startAngle + gapAngle;
  // Effective angle is reduced by the gap (if any).
  const effectiveAngle = fullAngle > gapAngle ? fullAngle - gapAngle : fullAngle;
  // Calculate the arc length for the effective angle.
  const effectiveArcLength = (effectiveAngle / 360) * circumference;
  // Generate the SVG path for the arc.
  const arcPath = describeArc(cx, cy, radius, startAngle, startAngle + effectiveAngle);

  return (
    <path
      d={arcPath}
      fill='transparent'
      stroke={segment.color}
      strokeWidth={strokeWidth}
      strokeLinecap='butt'
      style={{
        transition: 'transform 0.4s ease, stroke-dashoffset 1s ease',
        transform: isActive ? 'scale(1.05)' : 'scale(1)',
        transformOrigin: 'center',
        strokeDasharray: effectiveArcLength,
        strokeDashoffset: animateFill ? 0 : effectiveArcLength
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick && (event => onClick(event, segment))}
    />
  );
};

export default DoughnutSegment;
